module.exports = __webpack_public_path__ + "img/气动扳手.844c6355.png";